import * as questionIds from "../../consultationQuestions/questionIds";

export const msdQuestions = [
    {
        id: questionIds.MsdAssessmentUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.MsdAssessmentUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.DemonstratedFullMovementOfNeck,
        questionText: "Neck",
    },
    {
        id: questionIds.DemonstratedFullMovementOfBack,
        questionText: "Back",
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftShoulder,
        questionText: "Left Shoulder",
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftElbow,
        questionText: "Left Elbow",
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightShoulder,
        questionText: "Right Shoulder",
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightElbow,
        questionText: "Right Elbow",
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftWrist,
        questionText: "Left Wrist",
    },
    {
        id: questionIds.DemonstratedFullMovementOfLeftLeg,
        questionText: "Left Leg",
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightWrist,
        questionText: "Right Wrist",
    },
    {
        id: questionIds.DemonstratedFullMovementOfRightLeg,
        questionText: "Right Leg",
    },
    {
        id: questionIds.DoRestrictionsAffectPerformance,
        questionText: "Do any restrictions affect the performance of your role?",
    },
    {
        id: questionIds.DoRestrictionsAffectPerformanceNotes,
        questionText: "Details/Note",
    },
];
